<template>
    <div ref="input" class="builder-idents-input">
        <default-title small coal v-if="label" :class="{ 'mb-28': !description, 'mb-4': description }">
            {{ label }}<template v-if="!description">:</template>
        </default-title>
        <default-title small color="#98A2B0" :font-size="12" v-if="description" class="mb-25">
            {{ description }}
        </default-title>
        <portal to="modals">
            <div
                v-click-outside="hideModal"
                v-if="modalPosition"
                :style="{ top: `${modalPosition.y + 35}px`, left: `${modalPosition.x}px` }"
                class="builder-idents-input__modal"
            >
                <div class="flex items-center">
                    <input
                        @wheel.stop
                        @input="handleManualInput($event.target.value)"
                        :value="editValue"
                        class="builder-idents-input__input mr-10 relative input"
                    />

                    <input
                        :value="editValue"
                        @input="editValue = $event.target.value"
                        class="range-input__slider"
                        type="range"
                        min="0"
                        max="100"
                        step="1"
                        :style="{
                            background: `linear-gradient(
                        90deg,
                         #3965FF 0%,
                         #3965FF ${editValue}%,
                        rgba(221,221,221,1) ${editValue}%,
                        rgba(221,221,221,1) 100%
                    )`
                        }"
                    />
                </div>
                <div class="flex mt-4">
                    <div
                        :class="{
                            'builder-idents-input__input_active': editValue === defaultIdent,
                            'mr-10': index !== defaultIdents.length - 1
                        }"
                        class="builder-idents-input__input relative hover"
                        :key="index"
                        v-for="(defaultIdent, index) in defaultIdents"
                        @click="editValue = defaultIdent"
                    >
                        {{ defaultIdent }}
                    </div>
                </div>
                <button @click="editValue = 0" class="flex mt-7 mb-7 items-center">
                    <UndoSmallIcon />
                    <p class="builder-idents-input__text static">
                        {{ t("letter-builder.reset") }}
                    </p>
                </button>
                <div class="builder-idents-input__divider mb-5"></div>
                <p style="color: #b5c1d2" class="builder-idents-input__text static">
                    {{ t("letter-builder.reset_descr") }}
                </p>
            </div></portal
        >

        <div class="builder-idents-input__container builder-idents-input__container_outer">
            <div class="builder-idents-input__line">
                <p class="builder-idents-input__text">
                    {{ t("letter-builder.outside") }}
                </p>
                <div
                    @click="openModal($event, 'm0')"
                    :class="{ 'builder-idents-input__input_active': activeIdent === 'm0' }"
                    class="builder-idents-input__input builder-idents-input__input_top"
                >
                    {{ margin[0] }}
                </div>
                <div
                    @click="openModal($event, 'm1')"
                    :class="{ 'builder-idents-input__input_active': activeIdent === 'm1' }"
                    class="builder-idents-input__input builder-idents-input__input_right"
                >
                    {{ margin[1] }}
                </div>
                <div
                    @click="openModal($event, 'm2')"
                    :class="{ 'builder-idents-input__input_active': activeIdent === 'm2' }"
                    class="builder-idents-input__input builder-idents-input__input_bottom"
                >
                    {{ margin[2] }}
                </div>
                <div
                    @click="openModal($event, 'm3')"
                    :class="{ 'builder-idents-input__input_active': activeIdent === 'm3' }"
                    class="builder-idents-input__input builder-idents-input__input_left"
                >
                    {{ margin[3] }}
                </div>
                <div class="builder-idents-input__container builder-idents-input__container_inner">
                    <div :class="{ disabled: !padding }" class="builder-idents-input__line">
                        <p class="builder-idents-input__text">
                            {{ t("letter-builder.inside") }}
                        </p>
                        <div
                            @click="openModal($event, 'p0')"
                            :class="{ 'builder-idents-input__input_active': activeIdent === 'p0' }"
                            class="builder-idents-input__input builder-idents-input__input_top"
                        >
                            {{ padding[0] || 0 }}
                        </div>
                        <div
                            @click="openModal($event, 'p1')"
                            :class="{ 'builder-idents-input__input_active': activeIdent === 'p1' }"
                            class="builder-idents-input__input builder-idents-input__input_right"
                        >
                            {{ padding[1] || 0 }}
                        </div>
                        <div
                            @click="openModal($event, 'p2')"
                            :class="{ 'builder-idents-input__input_active': activeIdent === 'p2' }"
                            class="builder-idents-input__input builder-idents-input__input_bottom"
                        >
                            {{ padding[2] || 0 }}
                        </div>
                        <div
                            @click="openModal($event, 'p3')"
                            :class="{ 'builder-idents-input__input_active': activeIdent === 'p3' }"
                            class="builder-idents-input__input builder-idents-input__input_left"
                        >
                            {{ padding[3] || 0 }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UndoSmallIcon from "@icons/UndoSmallIcon"
import ClickOutside from "vue-click-outside"
import DefaultTitle from "@components/Typography/DefaultTitle"

export default {
    name: "BuilderIdents",
    components: { DefaultTitle, UndoSmallIcon },
    directives: {
        ClickOutside
    },
    props: {
        label: {
            type: String,
            required: false
        },
        description: {
            type: String,
            required: false
        },
        margin: {
            type: Array,
            required: true,
            default: () => [0, 0, 0, 0]
        },
        padding: {
            type: [Array, Boolean],
            required: true,
            default: () => [0, 0, 0, 0]
        }
    },
    data() {
        return {
            modalPosition: null,
            activeIdent: null,
            defaultIdents: [0, 10, 20, 40, 60, 100],
            hasModalTimeout: false
        }
    },
    computed: {
        editValue: {
            get() {
                if (!this.activeIdent) {
                    return 0
                } else {
                    if (this.activeIdent[0] === "m") {
                        return this.margin[this.activeIdent[1]]
                    }
                    if (this.activeIdent[0] === "p") {
                        return this.padding[this.activeIdent[1]]
                    }
                    return 0
                }
            },
            set(value) {
                if (this.activeIdent[0] === "m") {
                    const newIdent = this.margin
                    newIdent[parseInt(this.activeIdent[1])] = value
                    this.$emit("update:margin", newIdent)
                    this.$set(this.margin, parseInt(this.activeIdent[1]), value)
                }
                if (this.activeIdent[0] === "p") {
                    const newIdent = this.padding
                    newIdent[parseInt(this.activeIdent[1])] = value
                    this.$emit("update:padding", newIdent)
                    this.$set(this.padding, parseInt(this.activeIdent[1]), value)
                }
            }
        }
    },
    methods: {
        hide() {
            if (!this.hasModalTimeout) {
                this.activeIdent = null
                this.modalPosition = null
            }
        },
        hideModal(event) {
            const select = window.getSelection()

            if (this.hasModalTimeout) {
                return
            }

            if (
                select &&
                select.type === "Range" &&
                select.anchorNode &&
                select.anchorNode.parentNode.closest(".builder-idents-input__modal")
            ) {
                event.preventDefault()
                return false
            }

            this.activeIdent = null
            this.modalPosition = null

            return true
        },
        handleManualInput(value) {
            if (/[0-9]/.test(value) || value === "") {
                this.editValue = parseInt(value)
            }
            this.$forceUpdate()
        },
        openModal(ev, value) {
            this.hasModalTimeout = true

            const { top: targetTop, left: targetLeft } = ev.target.getBoundingClientRect()
            this.activeIdent = value

            if (value[1] === "0" || value[1] === "2") {
                this.modalPosition = {
                    x: targetLeft - 256 / 2 + 15,
                    y: targetTop
                }
            }
            if (value[1] === "3") {
                this.modalPosition = {
                    x: targetLeft - 256 / 4 + 35,
                    y: targetTop
                }
            }
            if (value[1] === "1") {
                this.modalPosition = {
                    x: targetLeft - 256 + 35,
                    y: targetTop
                }
            }
            setTimeout(() => {
                this.hasModalTimeout = false
            }, 0)
        }
    }
}
</script>

<style lang="sass">
.range-input
    &__slider
        margin: 0
        appearance: none
        cursor: pointer
        width: 100%
        height: 6px
        border-radius: 5px
        outline: none
        position: relative
        z-index: 1
        &::-webkit-slider-thumb
            -webkit-appearance: none
            appearance: none
            border-radius: 50%
            width: 16px
            height: 16px
            background: #FFFFFF
            border: 1px solid #98A2B0
            cursor: pointer
        &::-moz-range-thumb
            border-radius: 50%
            width: 16px
            height: 16px
            background: #FFFFFF
            border: 1px solid #98A2B0
            cursor: pointer
.builder-idents-input
    position: relative
    &__divider
        width: 100%
        background-color: #F3F3F3
        height: 1px
    &__modal
        position: fixed
        z-index: 99999999999
        width: 256px
        box-shadow: 0px 4px 10px rgba(128, 158, 191, 0.15)
        border-radius: 7px
        text-align: center
        background-color: #fff
        padding: 10px
    &__text
        color: #52565C
        font-size: 10px
        font-weight: 400
        line-height: 12px
        position: absolute
        text-align: left
        top: 10px
        left: 10px
        &.static
            position: static
            margin-left: 2px
    &__input
        border: 1px solid #E0E0EC
        border-radius: 2px
        text-align: center
        width: 31px
        height: 24px
        position: absolute
        font-size: 10px
        color: #52565C
        font-weight: 600
        cursor: pointer
        user-select: none
        background-color: #fff
        display: flex
        align-items: center
        justify-content: center
        &.relative
            position: relative
        &.input
            cursor: text
        &.hover
            &:hover
                border-color: #3965FF
        &_active
            border-color: #3965FF
        &_top
            top: 0
            right: 50%
            transform: translate(50%, -50%)
        &_right
            top: 50%
            right: 0
            transform: translate(50%, -50%)
        &_bottom
            bottom: 0
            right: 50%
            transform: translate(50%, 50%)
        &_left
            top: 50%
            left: 0
            transform: translate(-50%, -50%)
    &__container
        position: relative
        background-color: #FAFCFF
        &_outer
            height: 140px
            margin-left: 12px
            margin-right: 12px
        &_inner
            height: 70px
            margin-left: 45px
            margin-right: 45px
            margin-top: 35px
    &__line
        border: 1px solid #B3C3DB
        border-radius: 4px
        height: 100%
</style>
